const miniFAQSection = $('#mini-faq-section');
const miniFAQButton = miniFAQSection.find('.button-parent');
const miniFAQCards = miniFAQSection.find('.faq-entity');
let miniFAQTL, miniFAQCardsTL;

const addMiniFAQCardsIn = () => {
  const miniFAQCardsTL = gsap.timeline({ paused: true });

  miniFAQCardsTL.add(elementInAnimationYWOpacity(miniFAQCards, '100%', 0, 1, 1, 1, 0, 0.1, 'start', 'inEasing', 'opacityInEasing').play(), 0.2);
  /*
  miniFAQCards.each(function (index) {
    //miniFAQCardsTL.add(addElementInAnimation($(this), '100%', 1, 0).play(), 0.1 * index + 0.2);
  });
  */

  return miniFAQCardsTL;
};

const addMiniFAQAnimation = () => {
  const gradientConfig = {
    gradient: 'linear-gradient(127deg, #081B48 0%, #8AD1DA 50%, #081B48 100%);',
    start: 120,
    end: 0,
  };

  const miniFAQTL = gsap.timeline({
    paused: true,
  });

  miniFAQTL.add(
    animateSectionTopperIn({
      sectionParent: miniFAQSection,
      gradientConfig: gradientConfig,
    }).play(),
    0
  );

  miniFAQTL.add(elementInAnimationYWOpacity(miniFAQButton, '150%', 0, 1, 1.33, 1.17).play(), 0);
  //miniFAQTL.add(addElementIn(miniFAQButton, `150%`, 1.33, 'pageInEasing').play(), 0);

  return miniFAQTL;
};

const initMiniFAQ = () => {
  miniFAQTL = addMiniFAQAnimation();
  miniFAQCardsTL = addMiniFAQCardsIn();
  ScrollTrigger.create({
    trigger: miniFAQSection,
    start: 'top top+=120%',
    end: 'top top',
    once: true,
    onUpdate: (self) => {
      miniFAQTL.progress(self.progress);
    },
  });
  ScrollTrigger.create({
    trigger: miniFAQSection,
    start: 'top top+=80%',
    end: 'top top',
    once: true,
    onEnter: () => {
      miniFAQCardsTL.play();
    },
  });

}

/*
$(window).on('load', () => {
  initMiniFAQ()
});
*/

addSectionObserver(miniFAQSection, initMiniFAQ, false);